import React from 'react';
import LinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

const LinearProgressWithLabel: React.FC<{ label: string; value?: number }> = ({
  label,
  value = undefined,
}) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
      <Box sx={{ flexGrow: 1, mr: 1 }}>
        <LinearProgress variant={value ? 'determinate' : 'indeterminate'} value={value} />
      </Box>
      <Box sx={{ minWidth: 35 }}>
        <Typography variant="body2" color="text.secondary">
          {`${label}...`}
        </Typography>
      </Box>
    </Box>
  );
};

export default LinearProgressWithLabel;
